import ConfirmationDialog from './ConfirmationDialog'

interface AreYouSureDialogProps {
  title: string
  message: string
  sureAction: () => void
  open: boolean
  hide: () => void
  approveButtonText?: string
}

export default function AreYouSureDialog(props: AreYouSureDialogProps) {
  return (
    <ConfirmationDialog
      title={props.title}
      content={props.message}
      handleRightButton={props.sureAction}
      leftButtonColor="black"
      handleClose={props.hide}
      handleLeftButton={props.hide}
      open={props.open}
      rightButton={props.approveButtonText}
    />
  )
}
